import { useContext } from 'react';

import { ProjectAlertContext } from './ProjectAlertContext';
import type { ProjectAlertState } from './ProjectAlertContext';

/**
 * Lấy trạng thái cảnh báo.
 *
 * Ném lỗi khi được gọi ngoài phạm vi cung cấp trạng thái. Đó là lỗi lập trình, và ném ngay cho ra
 * thông báo rõ ràng hơn nhiều so với việc trả về giá trị rỗng rồi để lỗi phát ra ở một chỗ khác
 * không liên quan.
 */
export function useProjectAlerts(): ProjectAlertState {
  const context = useContext(ProjectAlertContext);

  if (context === null) {
    throw new Error(
      'useProjectAlerts phải được gọi bên trong ProjectAlertProvider. '
      + 'Kiểm tra lại cây thành phần ở main.tsx.',
    );
  }

  return context;
}
